const EOL_LABELS = {
  EOL_202503: 'eol_202503',
  EOL_202602: 'eol_202602',
};

export { EOL_LABELS };
